import { motion } from "framer-motion";
import { CreditCard, Truck, Search, MessageCircle } from "lucide-react";
import { CIEDA_PHONE } from "@/lib/constants";

const trustItems = [
  {
    icon: CreditCard,
    title: "Paiement sécurisé",
    desc: "Wave, Orange Money ou à la livraison",
  },
  {
    icon: Truck,
    title: "Livraison Dakar",
    desc: "Livraison rapide dans tout Dakar",
  },
  {
    icon: Search,
    title: "Suivi en temps réel",
    desc: "Suivez votre commande à chaque étape",
  },
  {
    icon: MessageCircle,
    title: "Support WhatsApp",
    desc: CIEDA_PHONE,
  },
];

const TrustStrip = () => (
  <section className="py-6 md:py-8 bg-card border-b border-border">
    <div className="container-max px-5">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
        {trustItems.map((item, i) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.1 }}
            className="flex items-center gap-3"
          >
            <div className="w-10 h-10 rounded-xl bg-secondary/10 flex items-center justify-center flex-shrink-0">
              <item.icon size={18} className="text-secondary" />
            </div>
            <div className="min-w-0">
              <p className="text-sm font-semibold text-foreground leading-tight">
                {item.title}
              </p>
              <p className="text-xs text-muted-foreground leading-tight mt-0.5 truncate">
                {item.desc}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default TrustStrip;
